import { Pipe, PipeTransform } from '@angular/core';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

const VISIBLE_TAIL_DIGITS = 4;

@Pipe({
  name: 'phoneDisplayFormat'
})
export class PhoneDisplayFormatPipe implements PipeTransform {
  transform(phoneNumber: string, unmask: boolean = true): string {
    if (!phoneNumber) return '';

    let formatted: string;

    if (phoneNumber.startsWith('+')) {
      try {
        const parsed = parsePhoneNumberFromString(phoneNumber);
        if (parsed && parsed.isValid()) {
          const intl = parsed.formatInternational();
          const nationalFormatted = parsed.formatNational();
          formatted = intl === phoneNumber ? `+${parsed.countryCallingCode} ${nationalFormatted}` : intl;
        } else {
          formatted = phoneNumber;
        }
      } catch {
        formatted = phoneNumber;
      }
    } else {
      if (phoneNumber.length === 9) {
        formatted = `${phoneNumber.substring(0, 3)}-${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6, 9)}`;
      } else if (phoneNumber.length === 10) {
        formatted = `(${phoneNumber.substring(0, 3)})${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6, 8)}-${phoneNumber.substring(8, 10)}`;
      } else if (phoneNumber.length === 11) {
        formatted = `${phoneNumber.substring(0, 1)}(${phoneNumber.substring(1, 4)})${phoneNumber.substring(4, 7)} ${phoneNumber.substring(7, 9)} ${phoneNumber.substring(9, 11)}`;
      } else {
        formatted = phoneNumber;
      }
    }

    if (unmask !== false) return formatted;

    const digits = formatted.replace(/\D/g, '');
    if (digits.length <= VISIBLE_TAIL_DIGITS) return '***';
    const visible = digits.slice(-VISIBLE_TAIL_DIGITS);
    const masked = '*'.repeat(digits.length - VISIBLE_TAIL_DIGITS) + visible;
    let out = '';
    let j = 0;
    for (let i = 0; i < formatted.length && j < masked.length; i++) {
      if (/\d/.test(formatted[i])) {
        out += masked[j++];
      } else {
        out += formatted[i];
      }
    }
    return out + (j < masked.length ? masked.slice(j) : '');
  }
}
